/* eslint-disable max-len */

import { client } from '../../../../../common-utils/libraries/axios/axios';
import { REMOTE_COLLECTION } from '../apiUrls';
import { buildUrl } from '@/common-utils/functions/restUtils';
import remoteCollectionFields from '../../fields/remoteCollectionFields';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.label string
 * @param responseData.provider string
 * @param responseData.status string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param response
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData(responseData) {
    const data = {};
    data[remoteCollectionFields.TOTAL_REVENUE.key] = responseData[remoteCollectionFields.TOTAL_REVENUE.key];
    return data;
}

const queryGetTotalRevenue = (query, enabled) => {
    return {
        queryKey: [REMOTE_COLLECTION.TOTAL_REVENUE.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(REMOTE_COLLECTION.TOTAL_REVENUE.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetTotalRevenue;